import { useEffect } from 'react'

const FAVICONS = {
  superadmin: '/favicon-superadmin.svg',
  admin:      '/favicon-admin.svg',
  default:    '/favicon.svg',
}

export function useFavicon(role) {
  useEffect(() => {
    const href = FAVICONS[role] ?? FAVICONS.default
    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      link.type = 'image/svg+xml'
      document.head.appendChild(link)
    }
    link.href = href
  }, [role])
}
